import { Injectable } from '@angular/core';
import { IDynamicControlsSharedState } from '../models/device';

export class DynamicControlsSharedState implements IDynamicControlsSharedState {
    private count: number = 0;

    public nextId() {
        return `device_input${this.count++}`;
    }
}
@Injectable({
    providedIn: 'root'
})
export class DynamicControlsSharedStateService {
    public static $name: string = 'dynamicControlsSharedStateFactory';

    public create() {
        return new DynamicControlsSharedState();
    }
}
